/**
 * Route for `igaming-ngr-ggr`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingNgrGgrPage } from "../features/igaming-ngr-ggr/IgamingNgrGgrPage";

export const igamingNgrGgrRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-ngr-ggr",
	component: IgamingNgrGgrPage,
});

export default igamingNgrGgrRoute;
